import React from 'react';

import Modal from 'ui-library/modals/Modal';

import {getAvailableStructurePredictionModels, getModelDisplayName} from '../ScientificModelConstants';
import {SCIENTIFIC_MODEL} from '../ScientificModelConstants';
import {BoltzGenInputForm} from './boltzgen/BoltzGenInputForm';
import StructurePredictionForm from './structure-prediction/StructurePredictionForm';

export interface ScientificModelInputFormProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputForm({
  model,
  onRequestClose,
}: ScientificModelInputFormProps): JSX.Element {
  if (model === SCIENTIFIC_MODEL.BOLTZGEN) {
    return <BoltzGenInputForm onRequestClose={onRequestClose} />;
  } else if (getAvailableStructurePredictionModels().includes(model)) {
    return <StructurePredictionForm onSubmit={onRequestClose} startingModel={model} />;
  } else {
    throw new Error(`Unsupported model type: ${model}`);
  }
}

export interface ScientificModelInputFormModalProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputFormModal({
  model,
  onRequestClose,
}: ScientificModelInputFormModalProps): JSX.Element {
  return (
    <Modal
      title={`Configure ${getModelDisplayName(model)}`}
      onRequestClose={onRequestClose}
      closeableOnBackgroundClick={true}
      large={true}
      fullHeight={true}
      bodyPadded={false}
    >
      <ScientificModelInputForm model={model} onRequestClose={onRequestClose} />
    </Modal>
  );
}
